var _defs, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommonBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    x2: 0,
    y1: 0,
    y2: "100%",
    gradientTransform: "rotate(240)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff"
  })), /*#__PURE__*/React.createElement("pattern", {
    patternUnits: "userSpaceOnUse",
    id: "b",
    width: 540,
    height: 450,
    x: 0,
    y: 0,
    viewBox: "0 0 1080 900"
  }, /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.1
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#444",
    points: "90 150 0 300 180 300"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90 150 180 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#AAA",
    points: "270 150 360 0 180 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DDD",
    points: "450 150 360 300 540 300"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#999",
    points: "450 150 540 0 360 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "630 150 540 300 720 300"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DDD",
    points: "630 150 720 0 540 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#444",
    points: "810 150 720 300 900 300"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "810 150 900 0 720 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DDD",
    points: "990 150 900 300 1080 300"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#444",
    points: "990 150 1080 0 900 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DDD",
    points: "90 450 0 600 180 600"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90 450 180 300 0 300"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#666",
    points: "270 450 180 600 360 600"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#AAA",
    points: "270 450 360 300 180 300"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DDD",
    points: "450 450 360 600 540 600"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#999",
    points: "450 450 540 300 360 300"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#999",
    points: "630 450 540 600 720 600"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "630 450 720 300 540 300"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "810 450 720 600 900 600"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DDD",
    points: "810 450 900 300 720 300"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#AAA",
    points: "990 450 900 600 1080 600"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#444",
    points: "990 450 1080 300 900 300"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#222",
    points: "90 750 0 900 180 900"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270 750 180 900 360 900"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DDD",
    points: "270 750 360 600 180 600"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "450 750 540 600 360 600"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "630 750 540 900 720 900"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#444",
    points: "630 750 720 600 540 600"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#AAA",
    points: "810 750 720 900 900 900"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#666",
    points: "810 750 900 600 720 600"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#999",
    points: "990 750 900 900 1080 900"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#999",
    points: "180 0 90 150 270 150"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#444",
    points: "360 0 270 150 450 150"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "540 0 450 150 630 150"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "900 0 810 150 990 150"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#222",
    points: "0 300 -90 450 90 450"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "0 300 90 150 -90 150"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "180 300 90 450 270 450"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#666",
    points: "180 300 270 150 90 150"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#222",
    points: "360 300 270 450 450 450"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "360 300 450 150 270 150"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#444",
    points: "540 300 450 450 630 450"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#222",
    points: "540 300 630 150 450 150"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#AAA",
    points: "720 300 630 450 810 450"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#666",
    points: "720 300 810 150 630 150"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "900 300 810 450 990 450"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#999",
    points: "900 300 990 150 810 150"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 600 -90 750 90 750"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#666",
    points: "0 600 90 450 -90 450"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#AAA",
    points: "180 600 90 750 270 750"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#444",
    points: "180 600 270 450 90 450"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#444",
    points: "360 600 270 750 450 750"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#999",
    points: "360 600 450 450 270 450"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#666",
    points: "540 600 630 450 450 450"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#222",
    points: "720 600 630 750 810 750"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "900 600 810 750 990 750"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#222",
    points: "900 600 990 450 810 450"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DDD",
    points: "0 900 90 750 -90 750"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#444",
    points: "180 900 270 750 90 750"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "360 900 450 750 270 750"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#AAA",
    points: "540 900 630 750 450 750"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "720 900 810 750 630 750"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#222",
    points: "900 900 990 750 810 750"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#222",
    points: "1080 300 990 450 1170 450"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "1080 300 1170 150 990 150"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1080 600 990 750 1170 750"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#666",
    points: "1080 600 1170 450 990 450"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#DDD",
    points: "1080 900 1170 750 990 750"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    fill: "url(#a)",
    width: "100%",
    height: "100%"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    fill: "url(#b)",
    width: "100%",
    height: "100%"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommonBg);
export default __webpack_public_path__ + "static/media/common-bg.9878fdbb0d963009b0721bda0026eea9.svg";
export { ForwardRef as ReactComponent };